var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "signinForm", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { md: "12" } }, [
            _c("div", { staticClass: "sign" }, [
              _c("div", { staticClass: "logo" }),
              _vm._v(" "),
              _c("h3", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("signup.head"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "welform" },
                [
                  _vm.showInvitation
                    ? _c(
                        "div",
                        { staticClass: "invitation" },
                        [
                          !_vm.invitationSent
                            ? _c(
                                "div",
                                [
                                  _c("svg-image", {
                                    attrs: { image: "iconNew" },
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("signup.form.invitation.head")
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        block: "",
                                        disabled: _vm.loading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.useOldData.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.loading
                                        ? _c("b-spinner", {
                                            attrs: { small: "" },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("signup.form.invitation.reuse")
                                        )
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("signup.form.separator")
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        block: "",
                                        disabled: _vm.loading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.daleteOldData.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.loading
                                        ? _c("b-spinner", {
                                            attrs: { small: "" },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("signup.form.invitation.new")
                                        )
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.$t("signup.agree")),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c("div", [
                                _c("hr"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "successAlert" },
                                  [
                                    _c("svg-image", {
                                      attrs: { image: "iconEnvelope" },
                                    }),
                                    _vm._v(" "),
                                    _c("h6", { staticClass: "text-center" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "signup.form.invitation.sent.label"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "text-center" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "signup.form.invitation.sent.desc"
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("hr"),
                              ]),
                          _vm._v(" "),
                          _c("alert", { attrs: { status: _vm.status } }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showOtp
                    ? _c(
                        "b-form",
                        { on: { submit: _vm.onOtp, resend: _vm.resendOtp } },
                        [
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "otpAlert" },
                            [
                              _c("svg-image", { attrs: { image: "iconOTP" } }),
                              _vm._v(" "),
                              _c("h6", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(_vm.$t("signup.otp.label"))),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-center" }, [
                                _vm._v(_vm._s(_vm.$t("signup.otp.desc"))),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "otp-group",
                                label: _vm.$t("signup.otp.form"),
                                "label-for": "otp",
                              },
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "otp",
                                  type: "number",
                                  required: "",
                                  state: _vm.formOtpStatus.otpCode.state,
                                },
                                model: {
                                  value: _vm.formOtp.otpCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formOtp, "otpCode", $$v)
                                  },
                                  expression: "formOtp.otpCode",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "b-form-invalid-feedback",
                                {
                                  attrs: {
                                    state: _vm.formOtpStatus.otpCode.state,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.formOtpStatus.otpCode.message
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-valid-feedback",
                                {
                                  attrs: {
                                    state: _vm.formOtpStatus.otpCode.state,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.formOtpStatus.otpCode.message
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("alert", { attrs: { status: _vm.status } }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "clearfix" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "float-right",
                                  attrs: {
                                    type: "submit",
                                    block: "",
                                    variant: "outline-primary",
                                    size: "lg",
                                    disabled: _vm.loading,
                                  },
                                },
                                [
                                  _vm.loading
                                    ? _c("b-spinner", { attrs: { small: "" } })
                                    : _vm._e(),
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("signup.otp.btn"))
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showForm
                    ? _c(
                        "b-form",
                        { on: { submit: _vm.onSubmit, reset: _vm.onReset } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "email-group",
                                label: _vm.$t("signup.form.email"),
                                "label-for": "email",
                                description: "",
                              },
                            },
                            [
                              _c(
                                "b-input-group",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: "email",
                                      type: "email",
                                      required: "",
                                      placeholder: "",
                                      state: _vm.emailState.state,
                                      disabled:
                                        _vm.checkingEmail || _vm.emailChecked,
                                    },
                                    on: { change: _vm.emailChanged },
                                    model: {
                                      value: _vm.form.ptmmEmail,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "ptmmEmail", $$v)
                                      },
                                      expression: "form.ptmmEmail",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.showCheckButton
                                    ? _c(
                                        "b-input-group-append",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant: "primary",
                                                disabled: _vm.checkingEmail,
                                              },
                                              on: { click: _vm.checkEmail },
                                            },
                                            [
                                              _vm.checkingEmail
                                                ? _c("b-spinner", {
                                                    attrs: { small: "" },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.checkingEmail
                                                ? _c("b-icon", {
                                                    attrs: { icon: "search" },
                                                  })
                                                : _vm._e(),
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "signup.form.check"
                                                      )
                                                    )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-invalid-feedback",
                                { attrs: { state: _vm.emailState.state } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.emailState.message) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form-valid-feedback",
                                { attrs: { state: _vm.emailState.state } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.emailState.message) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.emailInUSe
                            ? _c("div", { staticClass: "text-center" }, [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("signup.form.used")
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "resendBtn",
                                    attrs: {
                                      type: "resend",
                                      disabled: _vm.resendingEmail,
                                    },
                                    on: { click: _vm.resendVerificationEmail },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("signup.form.resendCode"))
                                    ),
                                  ]
                                ),
                                _vm._v(".\n\t\t\t\t\t\t"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.emailChecked
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "name-group",
                                        label: _vm.$t("signup.form.name"),
                                        "label-for": "name",
                                        description:
                                          _vm.$t("signup.form.named"),
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: { id: "name", required: "" },
                                        model: {
                                          value: _vm.form.ptmmFullName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "ptmmFullName",
                                              $$v
                                            )
                                          },
                                          expression: "form.ptmmFullName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "gender-group",
                                        label: _vm.$t("signup.form.gender"),
                                        "label-for": "gender",
                                      },
                                    },
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "gender",
                                          options: _vm.gender,
                                          required: "",
                                        },
                                        model: {
                                          value: _vm.form.ptmmGender,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "ptmmGender",
                                              $$v
                                            )
                                          },
                                          expression: "form.ptmmGender",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        id: "password-group",
                                        label: _vm.$t("signup.form.pwd"),
                                        "label-for": "password",
                                      },
                                    },
                                    [
                                      _c(
                                        "b-input-group",
                                        [
                                          _c("b-form-input", {
                                            class: {
                                              valid:
                                                _vm.passwordValidation.valid,
                                            },
                                            attrs: {
                                              id: "password",
                                              type: _vm.passwordVisible
                                                ? "text"
                                                : "password",
                                              required: "",
                                              placeholder: _vm.$t(
                                                "signup.form.pwdplace"
                                              ),
                                              state: _vm.passwordChecker,
                                            },
                                            model: {
                                              value: _vm.form.ptmmPassword,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "ptmmPassword",
                                                  $$v
                                                )
                                              },
                                              expression: "form.ptmmPassword",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "b-input-group-append",
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "hideandseek",
                                                  attrs: {
                                                    variant: "info",
                                                    "arial-label":
                                                      _vm.passwordVisible
                                                        ? "Hide password"
                                                        : "Show password",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.togglePasswordVisibility,
                                                  },
                                                },
                                                [
                                                  _c("b-icon", {
                                                    attrs: {
                                                      icon: _vm.passwordVisible
                                                        ? "eye-slash-fill"
                                                        : "eye-fill",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-input", {
                                        staticClass: "mt-2",
                                        attrs: {
                                          id: "checkPassword",
                                          type: "password",
                                          required: "",
                                          placeholder: _vm.$t(
                                            "signup.form.rpwdplace"
                                          ),
                                          state: _vm.passwordChecker,
                                        },
                                        model: {
                                          value: _vm.checkPassword,
                                          callback: function ($$v) {
                                            _vm.checkPassword = $$v
                                          },
                                          expression: "checkPassword",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "b-form-invalid-feedback",
                                        {
                                          attrs: { state: _vm.passwordChecker },
                                        },
                                        [
                                          _c(
                                            "ul",
                                            [
                                              _vm._l(
                                                _vm.passwordValidation.errors,
                                                function (error) {
                                                  return _c("li", [
                                                    _vm._v(_vm._s(error)),
                                                  ])
                                                }
                                              ),
                                              _vm._v(" "),
                                              _vm.notSamePasswords
                                                ? _c("li", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "signup.form.errmsg5"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b-form-valid-feedback", {
                                        attrs: { state: _vm.passwordChecker },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("alert", {
                                    attrs: { status: _vm.status },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "clearfix" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            squared: "",
                                            block: "",
                                            variant: "outline-primary",
                                            size: "lg",
                                            type: "submit",
                                            disabled:
                                              _vm.loading ||
                                              !_vm.passwordChecker,
                                          },
                                        },
                                        [
                                          _vm.loading
                                            ? _c("b-spinner", {
                                                attrs: {
                                                  small: "",
                                                  type: "grow",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            " " + _vm._s(_vm.$t("signup.btn"))
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("signup.agree")
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          !_vm.showInvitation
            ? _c(
                "div",
                { staticClass: "overlapButton" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        squared: "",
                        block: "",
                        variant: "primary",
                        to: "/signin",
                        size: "lg",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("signup.in")))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/SignupView.vue